<section modalContainer scrollEnabled>
    <app-modal-header header>스토어 메뉴 관리</app-modal-header>
    <div class="flex flex-col p-4 gap-4">
        <div
            cdkDropList
            (cdkDropListDropped)="drop($event)"
            class="flex flex-col gap-1 w-[50rem] h-[50rem]"
        >
            @for(menu of menuArray(); track $index){
            <app-store-menu-item
                (refresh)="handleReload()"
                [menus]="menus()!"
                [type]="menu.type"
            />
            }
        </div>
    </div>
</section>
